fragment ConversionAreaOneFragment on conversionAreaOne_Entry {
  typeHandle
  isAdjusted
  shopifyHandle
  injectedVideo {
    id
    url
    title
  }
  showBenefits
  showPaypalHint
  showRating
  showVariantPriceDifference
  showSizeAttentionText
  showSizeTable
  sizeTableButtonText
}
